// 表单验证方法集
var formValidation = {
  userFeedback: function userFeedback(data) {
    // console.log(data)
    if( data.category == 6 ){

      if (!data.bp_file) {
        showWarning("请上传相关文件！");
        return false;
      }
    }else {
      if (!data.message) {
        showWarning("请填写需要纠正的内容！");
        return false;
      }
    }
    return true;
  },
};
var PROD = {};
PROD._token = $.jStorage.get("localToken");
PROD._content = null;

PROD.exampleApi = {
  getExamBp: "example/add-bpview",
  getExamContact: "example/add-contact",
  getExamDetail: "example/detail"
};
PROD.feedbackData = {
  bp_file: "",
  bp_file_name: ""
}
PROD.init = function() {
  PAY.getProjectstatus(function() {
    PROD.getDetail(
      {
        id: projectid
      },
      PROD.showDetail
    );
  });

  PROD.enableCollect();

  PROD.enableScrollSpy();

  PROD.enableShowContactBp();
  PROD.enableShowAvg();
  PROD.enableShowBusi();
  PROD.enableShowAvgData();
  PROD.enableProjectFeedBack();
  PROD.enableFooterScroll();
  if(is_unexample){
    $.ajax({
      url: v1url + "public/status",
      type: "GET",
      headers: {
        token: PROD._token
      },
      success: function(data) {
        // console.log(data);
        if(data.code == 1000) {
          if (
            data.data.content.is_investor == 0 &&
            data.data.content.is_pay_order != 0
          ) {
            $("#no-auth1").hide();
            $("#no-auth2").show();
    
            $("#noAuthModal .no").hide();
            $("#noAuthModal .ok").show();
          }
        }
      }
    });
  }
  // 新增相关新闻、所在专辑、招聘信息维度展示
  PROD.showArticleAlbumRecruitList.init();
  // 上传BP的注册事件
  PROD.handleUploadBpEvent();
};

PROD.handleUploadBpEvent = function() {
  // 上传BP--- start
  $(".js-upload-bp").on("change", function(e) {
    var uploadFile = qp_uploadFile;
    let fileData = e.target.files[0];
    let fileType = uploadFile.getFileType(fileData.name);
    let typeFilter = uploadFile.filterType(["pdf"])(fileType);
    let sizeFilter = fileData.size > 10485760;

    if (typeFilter) {
      toastr.warning("目前仅支持pdf文件");
      return;
    }
    if (sizeFilter) {
      toastr.warning("文件大小限制在10M以内");
      return;
    }

    // $(".filename").text(fileData.name);
    // $(".fileprogress").text("进度：" + 0 + "% ");

    uploadFile.getUploadToken({ uptype: 5, ext: fileData.name }, function(res) {
      // 调用sdk上传接口获得相应的observable，控制上传和暂停
      let { key, uptoken } = res;
      uploadFile.uploadFile({
        fileData,
        key,
        uptoken,
        next(res) {
          let total = res.total;
          // console.log("1073==>total:", total);
          // $(".fileprogress").text("进度：" + total.percent + "% ");
        },
        complete(res) {
          PROD.feedbackData["bp_file"] = res.key;
          PROD.feedbackData["bp_file_name"] = fileData.name;
          $(".js-projectFeedback-bp-modal .modal-body .js-bp-name").html(`<a class="bp_download" href='${imgUrl}${res.key}' target="_blank" download='${fileData.name}'>${fileData.name}</a>`).show();
          closeLoadingGif();
        }
      });
    });
  });
}
// 底部操作栏定位
PROD.enableFooterScroll = function() {
  $(window).scroll(function(){
    // var scrollX=document.documentElement.scrollLeft||document.body.scrollLeft;//分别兼容ie和chrome
    throttle(PROD.setFooterPosition);
  })
}

PROD.setFooterPosition = function () {
  let scrollButtom = UTL.getScrollBarPosition('buttom');
  if (scrollButtom <= 150) {
    $(".js-content-footer").removeClass("content-footer-fixed");
  } else {
    $(".js-content-footer").addClass("content-footer-fixed");
  }
}

// 项目纠错（原项目反馈）
PROD.enableProjectFeedBack = function() {
  $("body").on("click", ".js-project-feedBack", function() {
    PROD.feedbackData["category"] = $(this).attr("data-key");
    // console.log(PROD.feedbackData.category);
    if( PROD.feedbackData.category == 6 ) {
      $(".js-projectFeedback-bp-modal").modal('show');
    }else {
      $(".js-projectFeedback-modal").modal('show');
    }
  })

  // 提交反馈---关闭弹窗
  $(".js-projectFeedback-modal #img_close,.js-projectFeedback-bp-modal #img_close").on("click", function (e) {
    $(".js-projectFeedback-modal,.js-projectFeedback-bp-modal").modal("hide");
  });
  // 提交反馈---提交数据
  $(".js-projectFeedback-modal .modal-footer .feedback-btn,.js-projectFeedback-bp-modal .modal-footer .feedback-btn").on("click", function (e) {
    PROD.feedbackData["message"] = $(".js-projectFeedback-modal textarea").val();
    PROD.feedbackData["open_id"] = projectid;
    if (formValidation.userFeedback(PROD.feedbackData)) {
      PROD.addData("project-feedback/create", PROD.feedbackData, function (e) {
        // 反馈成功后，清空一下表单
        $(".js-projectFeedback-modal textarea").val('');
        $(".js-projectFeedback-bp-modal .modal-body .file-box").html('');
        PROD.feedbackData = {
          bp_file: "",
          bp_file_name: ""
        };
        $(".js-projectFeedback-modal,.js-projectFeedback-bp-modal").modal("hide");
        $("#feedback_confirm_modal").modal("show");
      });
    }
  });
  // 关闭提交反馈成功提示框
  $("#feedback_confirm_modal .btn-rt").on("click", function (e) {
    $("#feedback_confirm_modal").modal("hide");
  });
}
PROD.addData = function addData(api, datas, cb) {
  var that = this;
  showLoadingGif();
  $.ajax({
    url: "" + v1url + api,
    type: "POST",
    contentType: "application/json",
    dataType: "json",
    data: JSON.stringify(datas),
    headers: {
      token: PROD._token
    },
    success: function success(data) {
      if (data.code === -1) {
        reLoginOnUc();
        return;
      } else if (data.code === 1000) {
        cb && cb(data.data);
      } else {
        showWarning(data.message);
      }
      closeLoadingGif();
    }
  });
},

PROD.enableShowContactBp = function() {
  // 铅币体系改版（08.20）

  // 获取联系方式---start
  $("body").on("click", "#get-contact,.js-get-advisor-contact", function() {
    // 获取融资顾问ID；
    let advisorId = $(this).attr("data-id");
    console.log(advisorId);
    PROD.powerCert(PAY.api.prevAddContact, advisorId).then((data) => {
      $(".js-pre-add-contact .modal-body p").html(data.message);
      $(".js-pre-add-contact .modal-footer .footer-title").html(data.prompt);
      $(".js-pre-add-contact .modal-footer .comfirm-btn .btn-rt").attr("data-type", data.type);
      switch (data.type) {
        case 0:
          PROD.addContact(advisorId);
          break;
        case 1:
          $(".js-pre-add-contact .modal-footer .comfirm-btn .btn-rt").html(`<a href="/datacert?from=projectdetail&id=${projectid}">前往认证</a>`);
          $(".js-pre-add-contact").modal("show");
          break;
        case 2:
          $(".js-pre-add-contact .modal-footer .comfirm-btn .btn-rt").html('<a href="/recharge">请充值</a>');
          $(".js-pre-add-contact").modal("show");
          break;
        case 3:
          $(".js-pre-add-contact .modal-footer .comfirm-btn .btn-rt").html('确认支付');
          $(".js-pre-add-contact").modal("show");
          break;
        case 4:
          $(".js-pre-add-contact .modal-footer .comfirm-btn .btn-rt").html('确认');
          $(".js-pre-add-contact").modal("show");
          break;
        default:
          break;
      }
    })
  });

  $(".js-pre-add-contact .modal-footer .comfirm-btn .btn-rt").on('click', function(e) {
    let dataType = $(this).attr("data-type");
    if(dataType == 3 || dataType == 4){
      PROD.addContact();
    }
    $(".js-pre-add-contact").modal("hide");
  });

  $(".js-pre-add-contact .modal-footer .comfirm-btn .btn-lf").on('click', function(e) {
    $(".js-pre-add-contact").modal("hide");
  });
  // 获取联系方式---end

  // 委托联系---start
  $("body").on("click", "#entrustment-contact", function() {
    // if(PROD.content.isClaim == 0 && PROD.content.is_pay !=1 ){
    //   window.location = Pc_Url + "membership_plan";
    // }else {
    //   $("#entrustment_modal .modal-body p span").html(
    //     PROD._content.project.name
    //   );
    //   $("#entrustment_modal").modal("show");
    // }
    PROD.powerCert(PAY.api.committalPreAddContact).then((data) => {
      $(".js-entrustment-modal .modal-body p").html(data.message);
      $(".js-entrustment-modal .modal-footer .footer-title").html(data.prompt);
      $(".js-entrustment-modal .modal-footer .comfirm-btn .btn-rt").attr("data-type", data.type);
      switch (data.type) {
        case 0:
          PROD.postCommittalContact();
          break;
        case 1:
          $(".js-entrustment-modal .modal-footer .comfirm-btn .btn-rt").html(`<a href="/datacert?from=projectdetail&id=${projectid}">前往认证</a>`);
          $(".js-entrustment-modal").modal("show");
          break;
        case 4:
          $(".js-entrustment-modal .modal-footer .comfirm-btn .btn-rt").html('确认委托');
          $(".js-entrustment-modal").modal("show");
          break;
        default:
          break;
      }
    })
  });

  $(".js-entrustment-modal .modal-footer .comfirm-btn .btn-rt").on("click", function() {
    let dataType = $(this).attr("data-type");
    if(dataType == 4){
      PROD.postCommittalContact();
    }
    $(".js-entrustment-modal").modal("hide");
  });
  $(".js-entrustment-modal .modal-footer .comfirm-btn .btn-lf").on("click", function() {
    $(".js-entrustment-modal").modal("hide");
  });

  // 隐藏弹框
  // $("body").on("click", "#btn-lf", function() {
  //   $("#entrustment_modal").modal("hide");
  // });
  // $("body").on("click", "#btn-rt", function() {
  //   // console.log("调用委托接口！")
  //   PROD.postCommittalContact();
  // });
  $("body").on("click", "#comfirm-btn", function() {
    $("#confirm_modal").modal("hide");
    location.reload();
  });
  // 委托联系---end

  // 查看bp---start
  $("body").on("click", "#view-bp", function(e) {
    // e.preventDefault();
    // var is_pay = PROD.content.is_pay;
    // if (is_pay != 1 && PROD.content.isClaim == 0) {
    //   $("#noAuthModal").modal("show");
    //   return;
    // }
    // if (PROD.content.bp_view >= 8) {
    //   toastr.error("您今日BP查看数量已超过8次");
    //   return;
    // }
    // PROD.addBpView();
    PROD.powerCert(PAY.api.prevAddBpview).then((data) => {
      $(".js-pre-add-bp .modal-body p").html(data.message);
      $(".js-pre-add-bp .modal-footer .footer-title").html(data.prompt);
      $(".js-pre-add-bp .modal-footer .comfirm-btn .btn-rt").attr("data-type", data.type);
      switch (data.type) {
        case 0:
          PROD.addBpView();
          break;
        case 1:
          $(".js-pre-add-bp .modal-footer .comfirm-btn .btn-rt").html(`<a href="/datacert?from=projectdetail&id=${projectid}">前往认证</a>`);
          $(".js-pre-add-bp").modal("show");
          break;
        case 2:
          $(".js-pre-add-bp .modal-footer .comfirm-btn .btn-rt").html('<a href="/recharge">请充值</a>');
          $(".js-pre-add-bp").modal("show");
          break;
        case 3:
          $(".js-pre-add-bp .modal-footer .comfirm-btn .btn-rt").html('确认支付');
          $(".js-pre-add-bp").modal("show");
          break;
        default:
          break;
      }
    })
  });

  $(".js-pre-add-bp .modal-footer .comfirm-btn .btn-rt").on("click", function() {
    let dataType = $(this).attr("data-type");
    // console.log(dataType);
    if(dataType == 3){
      PROD.addBpView();
    }
    $(".js-pre-add-bp").modal("hide");
  });
  
  $(".js-pre-add-bp .modal-footer .comfirm-btn .btn-lf").on("click", function() {
    $(".js-pre-add-bp").modal("hide");
  });
  $(".js-check-bp .comfirm-btn .btn-rt").on("click", function() {
    $(".js-check-bp").modal("hide");
  });
  // 查看bp---start

  //带你走进付费or申请试用页面
  $("body").on("click", "#bp-buy", function(e) {
    e.preventDefault();
    window.location.href = Pc_Url + "buy";
  });
  $("body").on("click", "#bp-try", function(e) {
    e.preventDefault();
    window.location.href = Pc_Url + "try";
  });

  // 认领项目事件处理
  $("body").on("click", "#claim_project", function(e) {
    e.preventDefault();
    if(is_unexample) {
      $("#claim_confirm_modal .modal-body p").html("您已经认领过该项目了！");
      $("#claim_confirm_modal").modal("show");
    }else {
      $("#claim_confirm_modal .modal-body p").html("示例项目不能认领！");
      $("#claim_confirm_modal").modal("show");
    }
  });
  $("body").on("click", "#claim-comfirm-btn", function() {
    $("#claim_confirm_modal").modal("hide");
  });
};

PROD.powerCert = (cert_api, advisorId) => {
    let query = {
      project_id: projectid
    }
    if(!!advisorId) {
      query.adviser_id = advisorId;
    }
    let getRequest = new Promise((resolve, reject) => {
      $.ajax({
        url: `${v1url}${cert_api}`,
        type: "POST",
        data: query,
        headers: {
          devicetoken: cookie_PENCILNEWSID,
          token: PROD._token
        },
        dataType: "json",
        success: (data) =>  {
          if (data.code == 1000) {
            resolve(data.data);
          } else {
            toastr.error(data.message);
          }
        },
        error: (err) => {
          console.log(err);
          reject(err);
        }
      });
    });
    return getRequest;
}
// 提交委托联系请求
PROD.postCommittalContact = function() {
  $.ajax({
    url: v1url + PAY.api.newCommittlaContact,
    type: "POST",
    headers: {
      token: PROD._token,
      devicetoken: cookie_PENCILNEWSID
    },
    data: {
      project_id: PROD._content.project.id
    },
    success: function(data) {
      if (data.code == -1) {
        reLoginOnUc();
        return;
      }
      if (data.code === 1000) {
        $("#entrustment_modal").modal("hide");
        $("#confirm_modal .footer-title .end").html(PROD.committal_times - 1);
        $("#confirm_modal").modal("show");
      } else {
        $("#entrustment_modal").modal("hide");
        showWarning(data.message);
      }
    }
  });
};

// 显示/隐藏平均数模版和融资平均数
PROD.enableShowAvg = function() {
  var showAvg = false;
  var showAvgRound = false;
  $("body").on("click", "#avgBtn .avgBtn", function(e) {
    // console.log(e.target)
    // showAvg = !showAvg;
    // $("#busi-data .average-tab").toggle();
    // $("#busi-data .average-content").toggle();
    // if(showAvg){
    //     $(e.target).html("收起").css("color","#6c7179");
    // }else{
    //     $(e.target).html("查看相关行业平均值>").css("color","#2f7dff");
    // }
    $("#showBusiDataAvg").modal("show");
  });
  $("body").on("click", "#roundButton", function(e) {
    // showAvgRound = !showAvgRound;
    // $("#avgRoundTable").toggle()
    // if (showAvgRound) {
    //     $(e.target).html("收起").css("color", "#6c7179");
    // } else {
    //     $(e.target).html("查看相关行业融资平均值>").css("color", "#2f7dff");
    // }
    $("#showRoundDataAvg").modal("show");
  });
};

//切换展示平均数
PROD.enableShowAvgData = function() {
  var id;
  $("body").on("click", "#avgContent", function(e) {
    // console.log(e.target);
    id = $(e.target).attr("data-id");
    $(e.target)
      .addClass("active")
      .siblings()
      .removeClass("active");
    // console.log(id);
    if (id) {
      PROD.addAvgData(id);
    }
  });
};

// 显示更多业务或财务数据，收起
PROD.enableShowBusi = function() {
  $("body").on("click", "#view-busi", function(e) {
    $(".busiData .business:first")
      .siblings()
      .show();
    $(e.target).hide();
    $("#up-busi").show();
  });
  $("body").on("click", "#up-busi", function(e) {
    $(".busiData .business:first")
      .siblings()
      .hide();
    $(e.target).hide();
    $("#view-busi").show();
  });

  $("body").on("click", "#view-finan", function(e) {
    $(".finanData .finance:first")
      .siblings()
      .show();
    $(e.target).hide();
    $("#up-finan").show();
  });
  $("body").on("click", "#up-finan", function(e) {
    $(".finanData .finance:first")
      .siblings()
      .hide();
    $(e.target).hide();
    $("#view-finan").show();
  });
};

PROD.addAvgData = function(tag_id) {
  // console.log(PROD.content, PROD.avgTag);
  var content = PROD.content;
  var _project = $.extend({}, content.project, content.projectFollow);
  showLoadingGif();
  $.ajax({
    url: `${v1url}${is_unexample ? PAY.api.avgDetailPc : PAY.api.getExamAvgDetailPc}`,
    type: "GET",
    data: {
      tag_id: tag_id
    },
    headers: {
      devicetoken: cookie_PENCILNEWSID,
      token: PROD._token
    },
    dataType: "json",
    success: function(data) {
      if (data.code == 1000) {
        // console.log(data);
        PROD.showBusiDataAvg(_project, data.data.avgDetail);
      } else {
        toastr.error(data.message);
      }
      closeLoadingGif();
    },
    error: function() {}
  });
};

PROD.addBpView = function() {
  // var newTab = window.open("about:blank");
  var sa_obj = getCookie("sa_obj")
  var query = Object.assign({
    project_id: projectid
  }, {'sa-super-property':sa_obj});
  $.ajax({
    url: `${v1url}${is_unexample ? PAY.api.newAddBpView : PAY.api.getExamBp}`,
    type: "POST",
    data: query,
    headers: {
      devicetoken: cookie_PENCILNEWSID,
      token: PROD._token
    },
    dataType: "json",
    success: function(data) {
      if (data.code == 1000) {
        ga("send", "event", "项目详情页", "查看BP", PROD._content.project.name);
        PROD.newWin(data.data.content,'bplink')
        // newTab.location.href = `${data.data.content}`;
      } else {
        toastr.error(data.message);
      }
    },
    error: function() {}
  });
};

PROD.newWin = function(url, id) {
  // var a = document.createElement("a");
  // a.setAttribute("href", url);
  // a.setAttribute("target", "_blank");
  // a.setAttribute("id", id);
  // // 防止反复添加
  // if (!document.getElementById(id)) document.body.appendChild(a);
  // a.click();
  
  $(".js-check-bp .comfirm-btn .btn-rt a").attr('href', url);
  $(".js-check-bp").modal('show');
};

PROD.addContact = function(advisorId) {
  var sa_obj = getCookie("sa_obj")
  var query = Object.assign({
    project_id: projectid
  }, {'sa-super-property':sa_obj});
  if(!!advisorId) {
    query.adviser_id = advisorId;
  }
  $.ajax({
    url: `${v1url}${is_unexample ? PAY.api.newAddContact : PAY.api.getExamContact}`,
    type: "POST",
    data: query,
    headers: {
      devicetoken: cookie_PENCILNEWSID,
      token: PROD._token
    },
    dataType: "json",
    success: function(data) {
      if (data.code == 1000) {
        ga(
          "send",
          "event",
          "项目详情页",
          "获取联系方式",
          PROD._content.project.name
        );
        PROD.fillPersonModal(data.data.content);
      } else {
        toastr.error(data.message);
      }
    },
    error: function() {}
  });
};

PROD.fillPersonModal = function(sp) {
  var proj = $.extend({}, PROD._content.project, PROD._content.projectFollow);
  // console.log(proj)
  //修改弹窗html
  var m_html = `
         <div class="person-head-img">
         <img src=${
           PROD.content.project.logo_url
             ? `${PROD.content.project.logo_url}`
             : "../../imgs/pay/common/bird.png"
         } alt="">

             </div>
             <div class="project-name">
                 ${proj.name}
             </div>
             <div class="project-intro">
                 ${proj.introduce != null ? proj.introduce : ''}
             </div>
             <div class="contact-info-content">
                 <div class="person-info">
                     <div class="title">姓名：</div>
                     <div class="content">${sp.name}</div>
                 </div>
                 ${
                   sp.weixin
                     ? `<div class="person-info">
                     <div class="title">微信：</div>
                     <div class="content">${sp.weixin}</div>
                 </div>`
                     : ""
                 }
     ${
       sp.mobile
         ? `
     <div class="person-info">
     <div class="title">电话：</div>
     <div class="content">${sp.mobile}</div>
 </div>
     `
         : ""
     }
                 
             </div>
`;
  $("#contactModal .contact-info").html(m_html);
  $("#contactModal").modal("show");
};

PROD.enableScrollSpy = function() {
  var navH = 60;
  $("body").scrollspy({
    target: "#nav-bar",
    offset: navH
  });
  $(".nav-bar").on("click", "a", function(e) {
    e.preventDefault();
    var _id = $(this)
      .attr("href")
      .split("#")[1];
    var offset = $(`#${_id}`).offset();
    // console.log(offset)
    $(window).scrollTop(offset.top - navH + 62);
  });
};

PROD.enableCollect = function() {
  $("body").on("click", "#collect-project", function() {
    // console.log(PROD._content)
    if(is_unexample) {
      if (!PROD._content) return;
      if (PROD._content.is_collect == 1) {
        PROD.delCollect(projectid);
        return;
      }
      PROD.addCollect(projectid);
    }else {
      $("#claim_confirm_modal .modal-body p").html("示例项目不能关注！");
      $("#claim_confirm_modal").modal("show");
    }
  });
};

PROD.addCollect = function(id) {
  var sa_obj = getCookie("sa_obj")
  var query = Object.assign({
    project_id: projectid
  }, {'sa-super-property':sa_obj});
  $.ajax({
    url: `${v1url}${PAY.api.addCollect}`,
    type: "POST",
    data: query,
    headers: {
      devicetoken: cookie_PENCILNEWSID,
      token: PROD._token
    },
    dataType: "json",
    success: function(data) {
      if (data.code == 1000) {
        PROD._content.is_collect = 1;
        $("#collect-project").html("已关注");
        toastr.success("关注成功");
        ga(
          "send",
          "event",
          "项目详情页",
          "关注项目",
          PROD._content.project.name
        );
      } else if (data.code == -1) {
        toastr.error(data.message);
        //showPCLoginForm()
      }
    },
    error: function() {}
  });
};

PROD.delCollect = function(id) {
  var sa_obj = getCookie("sa_obj")
  var query = Object.assign({
    project_id: projectid
  }, {'sa-super-property':sa_obj});
  $.ajax({
    url: `${v1url}${PAY.api.deleteCollect}`,
    type: "POST",
    data: query,
    headers: {
      devicetoken: cookie_PENCILNEWSID,
      token: PROD._token
    },
    dataType: "json",
    success: function(data) {
      if (data.code == 1000) {
        PROD._content.is_collect = 0;
        $("#collect-project").html("关注项目");
        toastr.success("已取消关注");
        ga(
          "send",
          "event",
          "项目详情页",
          "取消关注项目",
          PROD._content.project.name
        );
      } else {
        toastr.error(data.message);
        //showPCLoginForm()
      }
    },
    error: function() {}
  });
};

PROD.getDetail = function(query, cb) {
  var sa_obj = getCookie("sa_obj")
  // console.log("神策公共信息：",sa_obj)
  query = Object.assign(query,{'sa-super-property':sa_obj});
  showLoadingGif();
  $.ajax({
    url: v1url + `${is_unexample ? "project/detail" : PAY.api.getExamDetail}`,
    type: "GET",
    data: query,
    headers: {
      devicetoken: cookie_PENCILNEWSID,
      token: PROD._token
    },
    dataType: "json",
    success: function(data) {
      if (data.code == 1000) {
        PROD._content = data.data.content;
        cb && cb(data);
      } else if (data.code == -1) {
        showPCLoginForm();
      } else {
        toastr.error(data.message);
      }
      closeLoadingGif();
    },
    error: function(err) {
      console.log(err)
    }
  });
};

PROD.showDetail = function(data) {
  var content = data.data.content;
  var avgData = data.data.avgDetail;
  var avgRounds = data.data.avgRounds;
  // console.log(data.data);
  // console.log("avgRounds:",avgRounds)
  // console.log("avgData:",avgData)
  var _project = $.extend({}, content.project, content.projectFollow);

  PROD.content = content;
  PROD.avgTag = !!avgData ? avgData : null;
  PROD.avgRounds = !!avgRounds ? avgRounds : null;
  if (
    content.projectFollow.is_round == 1 &&
    !!content.projectFollow.finance_round
  ) {
    PROD.round =
      !!avgData && avgData.rounds
        ? PAY.extractTheOne(
            avgData.rounds,
            "financing_rounds",
            content.projectFollow.finance_round
          )
        : null;
  }
  document.title = content.project.name;

  // 神策统计埋点
  var from_way = UTL.getUrlParam("from");
  var project_way = "其它";
  switch (from_way) {
    case "project_list":
      project_way = "项目列表";
      break;
    case "new_project_list":
      project_way = "项目列表";
      break;
    case "search_project_list":
      project_way = "搜索";
      break;
    case "competitive_project_list":
      project_way = "相关竞品";
      break;
    case "article_project":
      project_way = "文章详情";
      break;
    case "contact_project_list":
      project_way = "联系的项目";
      break;
    case "collect_project_list":
      project_way = "关注的项目";
      break;
    case "ugc_project":
      project_way = "个人项目";
      break;
    case "dynamics_project":
      project_way = "动态列表";
      break;
    case "album_list":
      project_way = "专辑详情";
      break;
    default:
      project_way = "其它";
      break;
  }
  sa.track("projectEntrance", {
    $lib_detail: "进入项目详情页##进入页面触发##projectdetail.js##624",
    way: project_way,
    projectID: content.project.id,
    projectName: content.project.name,
    hasBP: content.is_bp == 1 ? true : false,
    hasContact: content.is_contact == 1 ? true : false,
    "PlatformType": "PC"
  });

  PROD.showArticleLinks(content.article_links);
  PROD.showProjectData(_project, PROD.avgRounds);
  PROD.showBusiData(content.business_data, content.financial_data);
  if (PROD.avgTag) {
    PROD.addAvgData(PROD.avgTag[0].tag_id);
  }
  PROD.showAvgTag(PROD.avgTag);
  PROD.showBusiDataBtn(PROD.avgTag, _project);
  PROD.showIndustryData(_project);
  PROD.showTeamData(_project, content.people);
  PROD.showRoundData(content.rounds);
  PROD.showIndustryCommerce(content.business);

  PROD.showHeaderAndfooterView(_project, content.industries, content.isClaim);
  PROD.showFinancingAdvisorView(content.financing_advisor);
  PROD.showBpView({is_bp: content.is_bp, bp_file_name: content.projectFollow.bp_file_name, bp_visible: content.projectFollow.bp_visible});
  // $(".right_container,.left_container").show();
  $(".right_container").show();

  PROD.adjustNavItemWidth();
  PROD.adjustNavWidth();
};

PROD.showHeaderAndfooterView = function(proj, industries, isClaim) {
  // console.log(industries);
  let _html_header = ``;
  let _html_footer = ``;
  // console.log(proj, isClaim);
  _html_header += `
  <div class="project-logo">
                    <img src="${
                      proj.logo_url ? `${proj.logo_url}` : "../../imgs/pay/common/bird.png"
                    }" alt="" class="img-logo">
                </div>
                <div class="project-content clearfix">
                    <div class="project-name">${proj.name}
                      ${
                        proj.online_time
                          ? `<span class="project-buildtime">${proj.online_time.substr(
                              0,
                              7
                            )}</span>`
                          : ""
                      }
                    </div>
                    <div class="project-introduction">${proj.introduce ? proj.introduce : ""}</div>
                    ${
                      industries
                        ? `<span class="project-industry">${industries
                            .map(function(c) {
                              return c.name;
                            })
                            .join("/")}</span>`
                        : ""
                    }
                    <span class="project-salce">${proj.scale ? proj.scale : ""}</span>
                </div>
                <div class="project-right">
                    ${
                      is_unexample ?
                        isClaim == 1
                        ? `<span id="claim_project" class="project-claim has_claim_project">已认领此项目</span>`
                        : `<a href='/claim_project?id=${
                            proj.id
                              }' target='_blank'><span class="project-claim">认领此项目</span></a>`
                      : `<span id="claim_project" class="project-claim">认领此项目</span>`
                        }
                </div>
  `
  _html_footer += ``
    
  if (PROD.content.auth.is_contact_button == 0) {
    _html_footer += `
      <span class="btn-related" id="entrustment-contact">委托联系</span>
    `
  } else if (PROD.content.auth.is_contact_button == 1) {
    _html_footer += `
      <span class="btn-related-yes">
        已委托
      </span>
    `
  } else {
    _html_footer += `
      <span class="btn-related" id="get-contact">获取联系方式</span>
    `
  }

  _html_footer += `
      ${
        PROD.content.is_collect == 1
          ? `<span class="btn-fllow" id="collect-project">已关注</span>`
          : `
          <span class="btn-fllow" id="collect-project">关注项目</span>
      `
      }

  `;

  $('.js-project-header').html(_html_header);
  $('.js-footer-btn').html(_html_footer);
  $('.js-content-header').show();
  if(isClaim != 1) {
    $(".js-content-footer").show();
  } else{
    $(".js-content-footer").hide();
  }

}

PROD.showArticleLinks = function(links) {
  if (links.length == 0) {
    $(".related-article").hide();
    return;
  }
  var _html = "",
    i = 0,
    len = links.length;
  for (; i < len; i++) {
    var link = links[i];
    _html += `
    <div class="article-item">
        <a target="_blank" class="title" href="/p/${
          link.id
        }.html?from=projectdetail_article">
           ${link.title}
        </a>
        <div class="article-info">
            <div class="from">铅笔道</div>
            <div class="time">${link.publish_time.substr(0, 10)}</div>
        </div>
    </div>
        `;
  }

  $(".left-info .related-article").append(_html);
};

PROD.showProjectData = function(proj, avgRounds) {
  //test
  // proj.android_url='www.a'
  // proj.ios_url='www.b'
  // console.log("proj",proj)
  var hasWechat = PAY.judgeWechatId(proj.project_public_num);
  var product_desc_Multi = PAY.multiLineShow(proj.product_desc);
  var product_feature_Multi = PAY.multiLineShow(proj.product_feature);

  // console.log(product_desc_Multi);
  // console.log(PAY.hasGivenStr(proj.finance_money))
  var _html = "";
  _html += `
${
    proj.market_demand
      ? `<div class="item-box">
<div class="item-title">
市场需求：
</div>
<div class="item-content">
    ${PAY.multiLineShow(proj.market_demand)}
</div>
</div>`
      : ""
  }
${
    proj.description
      ? `<div class="item-box">
<div class="item-title">
业务描述：
</div>
<div class="item-content">
    ${proj.description}
</div>
</div>`
      : ""
  }

${
    proj.product_desc
      ? `<div class="item-box">
<div class="item-title">
产品介绍：
</div>
<div class="item-content">
    ${product_desc_Multi}
</div>
</div>`
      : ""
  }

${
    proj.product_feature
      ? `<div class="item-box">
<div class="item-title">
产品特点：
</div>
<div class="item-content">
    ${product_feature_Multi}
</div>
</div>`
      : ""
  }


${
    proj.user_portrait
      ? `<div class="item-box">
<div class="item-title">
用户画像：
</div>
<div class="item-content">
    ${proj.user_portrait}
</div>
</div>`
      : ""
  }


${
    proj.client_portrait
      ? `<div class="item-box">
<div class="item-title">
客户画像：
</div>
<div class="item-content">
    ${proj.client_portrait}
</div>
</div>`
      : ""
  }

${
    proj.supplier_type
      ? `<div class="item-box">
<div class="item-title">
供应商类型：
</div>
<div class="item-content">
    ${proj.supplier_type}
</div>
</div>`
      : ""
  }

${
    proj.income_source
      ? `<div class="item-box">
<div class="item-title">
收入来源：
</div>
<div class="item-content">
    ${proj.income_source}
</div>
</div>`
      : ""
  }

${
    proj.main_market
      ? `<div class="item-box">
<div class="item-title">
主攻市场：
</div>
<div class="item-content">
    ${proj.main_market}
</div>
</div>`
      : ""
  }

${
    proj.guest_way
      ? `<div class="item-box">
<div class="item-title">
获客方式：
</div>
<div class="item-content">
    ${PAY.multiLineShow(proj.guest_way)}
</div>
</div>`
      : ""
  }

${
    proj.company_website
      ? `<div class="item-box">
<div class="item-title">
官方网站：
</div>
<div class="item-content">
<a href=" ${UTL.httpWebsite(proj.company_website)}" target="_blank">
${proj.company_website}</a>
</div>
</div>`
      : ""
  }

${
    proj.android_url || proj.ios_url
      ? `<div class="item-box">
<div class="item-title">
APP下载地址：
</div>
<div class="item-content app">
${
          proj.android_url
            ? `<a href=" ${UTL.httpWebsite(proj.android_url)}" target="_blank">
安卓下载</a>`
            : ""
        }

${
          proj.ios_url
            ? `<a href=" ${UTL.httpWebsite(proj.ios_url)}" target="_blank">
IOS下载</a>`
            : ""
        }
</div>
</div>`
      : ""
  }

${
    proj.project_public_num
      ? `<div class="item-box public-num">
<div class="item-title">
微信公众号：
</div>
<div class="item-content">

${
          proj.project_public_num
            ? `<a target="_blank" class="pub">
${proj.project_public_num} ${
                hasWechat
                  ? `<img arlt="${
                      proj.project_public_num
                    }" src="https://open.weixin.qq.com/qr/code?username=${
                      proj.project_public_num
                    }" class="sub" width="150" height="150"></img>`
                  : ""
              }</a>`
            : ""
        }
</div>
</div>`
      : ""
  }

<div class="item-box">
<div class="item-title">
融资需求：
</div>
${
    proj.is_round == 1
      ? `<div class="item-content ">
    <table class="round-content">
        <tr>
            <td class="td-left">目标轮次</td>
            <td class="td-left">目标金额</td>
            <td class="td-left">出让比例</td>
        </tr>
        <tr>
            <td class="td-right">${
              PAY.financeTypesMap[proj.finance_round]
                ? PAY.financeTypesMap[proj.finance_round]
                : "暂无数据"
            }</td>
            <td class="td-right">${
              proj.finance_money ? proj.finance_money : "暂无数据"
            }</td>
            <td class="td-right">${
              proj.finance_scale ? proj.finance_scale + "%" : "暂无数据"
            }</td>
        </tr>
    </table>
    ${
      avgRounds && avgRounds.length > 0
        ? `<div id="roundButton" class="round-button">查看相关行业融资平均值></div>`
        : ""
    }
</div>`
      : '<div class="item-content ">未表明融资需求</div>'
  }
</div>
`;
  $("#project-data .section-content").html(_html);

  var _html2 = "";
  _html2 += `
        <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">x</button>
            <div class="avg-title">
                以下为相关行业${
                  PAY.financeTypesMap[proj.finance_round]
                    ? PAY.financeTypesMap[proj.finance_round]
                    : "暂无数据"
                }平均融资值，仅供参考：
            </div>
        </div>
        <div class="modal-body">
            <div class="round-table">
                <table>
                    <tr>
                        <td class="td-left">本项目/相关行业</td>
                        <td class="td-right">目标金额</td>
                        <td class="td-right">出让比例</td>
                    </tr>
                    <tr>
                        <td class="td-left">本项目</td>
                        <td class="td-content td-border">${
                          proj.finance_money
                            ? PAY.hasGivenStr(proj.finance_money) == false
                              ? proj.finance_money + "人民币"
                              : proj.finance_money
                            : "-"
                        }</td>
                        <td class="td-content td-border">${
                          proj.finance_scale ? proj.finance_scale + "%" : "-"
                        }</td>
                    </tr>
                    ${
                      avgRounds
                        ? avgRounds
                            .map(function(round) {
                              return `<tr>
                            <td class="td-left">${round.name}</td>
                            <td class="td-content-avg td-border">${round.financing_amount_avg ? (PAY.hasGivenStr(round.financing_amount_avg) == false ? round.financing_amount_avg + '人民币' : round.financing_amount_avg) : "-"}</td>
                            <td class="td-content-avg td-border">${round.transfer_proportion_avg ? round.transfer_proportion_avg : "-"}</td>
                        <tr>`
        }).join('') : ""}
                </table>
            </div>
        </div>
        <div class="modal-footer">

        </div>
    `;
  $("#showRoundDataAvg .modal-content").html(_html2);
};
PROD.showAvgTag = function(avgTag) {
  var _html = "";
  // if (PROD.content.is_pay != 1 && PROD.content.isClaim == 0) {
  //   $(".no-auth").show();
  //   $("#busi-data .average-content").hide();
  //   return;
  // }
  _html += `
    ${
      !!avgTag
        ? `
    <button type="button" class="close" data-dismiss="modal" aria-hidden="true">x</button>
    <div class="item-box">
        <div class="avg-title">
        以下为相关行业平均值，仅供参考：
        </div>
        <ul id="avgContent" class="avg-content clearfix">
            ${
              avgTag
                ? avgTag
                    .map(function(avg, index) {
                      if (index == 0) {
                        return (
                          '<li class="active" data-id=' +
                          avg.tag_id +
                          ">" +
                          avg.name +
                          "</li>"
                        );
                      } else {
                        return (
                          "<li data-id=" + avg.tag_id + ">" + avg.name + "</li>"
                        );
                      }
                    })
                    .join("")
                : ""
            }
        </ul>
        
    </div>`
        : ""
    }
    `;
  $("#showBusiDataAvg .modal-header").html(_html);
};
PROD.showBusiData = function(busiData, finanData) {
  var _html = "";
    if (PROD.content.auth.bf_show == 1) {
      $(".no-auth").show();
      $("#busi-data .section-content,#avgBtn").hide();
      return;
    } else if (PROD.content.auth.bf_show == 2) {
      $("#no-auth1").hide();
      $("#no-auth2").show();
      $(".no-auth").show();
      $("#busi-data .section-content,#avgBtn").hide();
      return;
    }else {
      if(busiData.length == 0 && finanData.length == 0){
        $("#busi-data").hide();
        $(".nav-bar-item")
          .eq(1)
          .hide();
        return;
      }
    }
  _html += `
        <div class="item-box item-box-busi">
        <div class="busiData">
        ${
          busiData
            ? busiData
                .map((proj, ind, data) => {
                  if (
                    !proj.user_nums &&
                    !proj.client_nums &&
                    !proj.new_day_increase &&
                    !proj.new_month_increase &&
                    !proj.day_live &&
                    !proj.uv &&
                    !proj.pv &&
                    !proj.month_rete_rate &&
                    !proj.week_rete_rate &&
                    !proj.day_rete_rate &&
                    !proj.average_used &&
                    !proj.cover_city_num &&
                    !proj.cover_cate_num &&
                    !proj.other_business &&
                    !proj.supplier_type &&
                    !proj.supplier_num &&
                    proj.custom_dimension.length == 0
                  ) {
                  } else {
                    // console.log(proj)
                    return `
            <div class="business">
                ${
                  ind == 0
                    ? `<div class="busi-title ">
                    业务数据
                </div>`
                    : ""
                }
                <div key=${ind} class="item-content busi-item-content">
                    <div class="user-data">

                    <div class="left clearfix">

                    ${
                      proj.user_nums
                        ? `<div class="data-item">
                    用户数量：<span>${proj.user_nums}</span>
                    </div>`
                        : ""
                    }

                    

                    ${
                      proj.new_day_increase
                        ? `<div class="data-item">
                    日新增：<span>${proj.new_day_increase}</span>
                    </div>`
                        : ""
                    }
                

                    ${
                      proj.new_month_increase
                        ? `<div class="data-item">
                    月新增：<span>${proj.new_month_increase}</span>
                    </div>`
                        : ""
                    }

                

                    ${
                      proj.day_rete_rate
                        ? `<div class="data-item">
                    日留存率：<span>${proj.day_rete_rate}</span>
                    </div>`
                        : ""
                    }

                
                    ${
                      proj.week_rete_rate
                        ? `<div class="data-item">
                    周留存率：<span>${proj.week_rete_rate}</span>
                    </div>`
                        : ""
                    }

                

                    ${
                      proj.month_rete_rate
                        ? `<div class="data-item">
                    月留存率：<span>${proj.month_rete_rate}</span>
                    </div>`
                        : ""
                    }

                    

                    ${
                      proj.day_live
                        ? `<div class="data-item">
                    平均日活：<span>${proj.day_live}日</span>
                    </div>`
                        : ""
                    }

                

                    ${
                      proj.average_used
                        ? `<div class="data-item">
                    平均使用时长：<span>${proj.average_used}</span>
                    </div>`
                        : ""
                    }

                    

                    ${
                      proj.uv
                        ? `<div class="data-item">
                    UV：<span>${proj.uv}</span>
                    </div>`
                        : ""
                    }

                    
                    ${
                      proj.pv
                        ? `<div class="data-item">
                    PV：<span>${proj.pv}</span>
                    </div>`
                        : ""
                    }

                    ${
                      proj.client_nums
                        ? `<div class="data-item">
                    客户数量：<span>${proj.client_nums}</span>
                    </div>`
                        : ""
                    }

                    

                    ${
                      proj.supplier_num
                        ? `<div class="data-item">
                    供应商数量：<span>${proj.supplier_num}</span>
                    </div>`
                        : ""
                    }
                

                    ${
                      proj.repeat_rate
                        ? `<div class="data-item">
                    复购率：<span>${proj.repeat_rate}</span>
                    </div>`
                        : ""
                    }

                
                    ${
                      proj.cover_city_num
                        ? `<div class="data-item">
                    覆盖城市数量：<span>${proj.cover_city_num}</span>
                    </div>`
                        : ""
                    }
                    
                    

                    ${
                      proj.cover_cate_num
                        ? `<div class="data-item">
                    覆盖品类数量：<span>${proj.cover_cate_num}</span>
                    </div>`
                        : ""
                    }

                    </div>

                    ${
                      proj.other_business
                        ? `<div class="data-item long">
                    其他业务数据：<span>${PAY.multiLineShow(
                      proj.other_business
                    )}</span>
                    </div>`
                        : ""
                    }
                    
                    ${
                      proj.custom_dimension && proj.custom_dimension.length > 0
                        ? proj.custom_dimension
                            .map(val => {
                              return `
                        <div class="data-item">
                        ${val.name}：<span>${val.value}</span>
                        </div>`;
                            })
                            .join("")
                        : ""
                    } 

                    <div class="collect-time">${proj.acquisition_time} 采集 ${
                      data.length > 1 && ind == 0
                        ? `<span id="view-busi">点击查看历史数据</span>`
                        : ""
                    }</div>
                    </div>
                </div>
            ${data.length > 1 ? `<hr/>` : ""}
            </div>
            `;
                  }
                })
                .join("")
            : ""
        }
        </div>
        <div class="retract"><span id="up-busi">收起</span></div>
    </div>
    `;
  // }

  _html += `
    <div class="item-box item-box-busi">
        <div class="finanData">
        ${
          finanData
            ? finanData
                .map((proj, ind, data) => {
                  if (
                    !proj.turnover &&
                    !proj.guest_price &&
                    !proj.order_num &&
                    !proj.sales &&
                    !proj.market_cost &&
                    !proj.project_cost &&
                    !proj.human_cost &&
                    !proj.mao_rate &&
                    !proj.net_profit &&
                    !proj.gross_profit &&
                    !proj.cash_flow &&
                    !proj.other_financial_data &&
                    !proj.other_cost &&
                    proj.custom_dimension.length == 0
                  ) {
                  } else {
                    return `
            <div class="finance">
                ${
                  ind == 0
                    ? `<div class="busi-title ">
                    财务数据
                </div>`
                    : ""
                }
                <div key=${ind} class="item-content busi-item-content">
                    <div class="user-data">

                    <div class="left clearfix">

                    ${
                      proj.cash_flow
                        ? `<div class="data-item">
                    现金流：<span>${proj.cash_flow}</span>
                    </div>`
                        : ""
                    }

                    
                    ${
                      proj.sales
                        ? `<div class="data-item">
                    销售额（月）：<span>${proj.sales}</span>
                    </div>`
                        : ""
                    }

                    

                    ${
                      proj.sales_grow
                        ? `<div class="data-item">
                    销售环比增速（月）：<span>${proj.sales_grow}</span>
                    </div>`
                        : ""
                    }

                    
                
                    ${
                      proj.order_num
                        ? `<div class="data-item">
                    订单量（月）：<span>${proj.order_num}</span>
                    </div>`
                        : ""
                    }


                    ${
                      proj.guest_price
                        ? `<div class="data-item">
                    客单价：<span>${proj.guest_price}</span>
                    </div>`
                        : ""
                    }

                

                    ${
                      proj.gross_profit
                        ? `<div class="data-item">
                    总利润：<span>${proj.gross_profit}</span>
                    </div>`
                        : ""
                    }

                    
                    ${
                      proj.turnover
                        ? `<div class="data-item">
                    交易额（月）：<span>${proj.turnover}</span>
                    </div>`
                        : ""
                    }

                    

                    ${
                      proj.mao_rate
                        ? `<div class="data-item">
                    毛利率：<span>${proj.mao_rate}</span>
                    </div>`
                        : ""
                    }


                    ${
                      proj.net_profit
                        ? `<div class="data-item">
                    净利润（月）：<span>${proj.net_profit}</span>
                    </div>`
                        : ""
                    }

                    

                    ${
                      proj.project_cost
                        ? `<div class="data-item">
                    产品成本（月）：<span>${proj.project_cost}</span>
                    </div>`
                        : ""
                    }

                    

                    ${
                      proj.market_cost
                        ? `<div class="data-item">
                    营销费用（月）：<span>${proj.market_cost}</span>
                    </div>`
                        : ""
                    }

                    

                    ${
                      proj.human_cost
                        ? `<div class="data-item">
                    人力费用：<span>${proj.human_cost}</span>
                    </div>`
                        : ""
                    }

                    ${proj.other_cost ? `<div class="data-item">
                    其他成本（月）：<span>${proj.other_cost}</span>
                    </div>`
                        : ""
                    }

                    </div>
                    
                    ${
                      proj.other_financial_data
                        ? `<div class="data-item long">
                    其他财务数据（月）：<span>${
                      proj.other_financial_data
                    }</span>
                    </div>`
                        : ""
                    }

                    ${
                      proj.custom_dimension && proj.custom_dimension.length > 0
                        ? proj.custom_dimension
                            .map(val => {
                              return `
                        <div class="data-item">
                        ${val.name}：<span>${val.value}</span>
                        </div>`;
                            })
                            .join("")
                        : ""
                    } 

                    <div class="collect-time">${proj.acquisition_time} 采集 ${
                      data.length > 1 && ind == 0
                        ? `<span id="view-finan">点击查看历史数据</span>`
                        : ""
                    }</div>
                    </div>
                
                </div>
            ${data.length > 1 ? `<hr/>` : ""}
            </div>
        `;
                  }
                })
                .join("")
            : ""
        }
       </div>
       <div class="retract"><span id="up-finan">收起</span></div>
    </div>
    `;
  // }

  $("#busi-data .section-content").html(_html);
};

PROD.showBusiDataAvg = function(proj, average) {
  var _html = "";
  // if (PROD.content.is_business_data && PROD.content.is_pay != 1 && PROD.content.isClaim == 0) {
  //   $(".no-auth").show();
  //   $("#busi-data .section-content").hide();
  //   return;
  // }
  if (
    !proj.user_nums &&
    !proj.client_nums &&
    !proj.new_day_increase &&
    !proj.new_month_increase &&
    !proj.day_live &&
    !proj.month_rete_rate &&
    !proj.week_rete_rate &&
    !proj.day_rete_rate &&
    !proj.average_used &&
    !proj.cover_city_num &&
    !proj.cover_cate_num &&
    !proj.supplier_type &&
    !proj.supplier_num
  ) {
  } else {
    _html += `
        <div class="busi-table">
            <div class="table-title">业务数据：</div>
            <table>
                <tr>
                    <td class="td-left">业务数据</td>
                    <td class="td-right">项目数据</td>
                    <td class="td-right">行业均值</td>
                </tr>
                ${
                  proj.user_nums
                    ? `<tr>
                    <td class="td-left">用户数量</td>
                    <td class="td-content">${
                      proj.user_nums ? proj.user_nums : ""
                    }</td>
                    <td class="td-content td-content-avg">${
                      average.user_nums ? average.user_nums : "-"
                    }</td>
                </tr>`
                    : ""
                }
                ${
                  proj.new_day_increase
                    ? `<tr>
                    <td class="td-left">日新增</td>
                    <td class="td-content">${
                      proj.new_day_increase ? proj.new_day_increase : ""
                    }</td>
                    <td class="td-content td-content-avg">${
                      average.new_day_increase ? average.new_day_increase : "-"
                    }</td>
                </tr>`
                    : ""
                }
                ${
                  proj.new_month_increase
                    ? `<tr>
                    <td class="td-left">月新增</td>
                    <td class="td-content">${
                      proj.new_month_increase ? proj.new_month_increase : ""
                    }</td>
                    <td class="td-content td-content-avg">${
                      average.new_month_increase
                        ? average.new_month_increase
                        : "-"
                    }</td>
                </tr>`
                    : ""
                }
                ${
                  proj.day_rete_rate
                    ? `<tr>
                    <td class="td-left">日存留率</td>
                    <td class="td-content">${
                      proj.day_rete_rate ? proj.day_rete_rate + "%" : ""
                    }</td>
                    <td class="td-content td-content-avg">${
                      average.day_rete_rate ? average.day_rete_rate + "%" : "-"
                    }</td>
                </tr>`
                    : ""
                }
                ${
                  proj.week_rete_rate
                    ? `<tr>
                    <td class="td-left">周存留率</td>
                    <td class="td-content">${
                      proj.week_rete_rate ? proj.week_rete_rate + "%" : ""
                    }</td>
                    <td class="td-content td-content-avg">${
                      average.week_rete_rate
                        ? average.week_rete_rate + "%"
                        : "-"
                    }</td>
                </tr>`
                    : ""
                }
                ${
                  proj.month_rete_rate
                    ? `<tr>
                    <td class="td-left">月存留率</td>
                    <td class="td-content">${
                      proj.month_rete_rate ? proj.month_rete_rate + "%" : ""
                    }</td>
                    <td class="td-content td-content-avg">${
                      average.month_rete_rate
                        ? average.month_rete_rate + "%"
                        : "-"
                    }</td>
                </tr>`
                    : ""
                }
                ${
                  proj.day_live
                    ? `<tr>
                    <td class="td-left">平均日活</td>
                    <td class="td-content">${
                      proj.day_live ? proj.day_live + "日" : ""
                    }</td>
                    <td class="td-content td-content-avg">${
                      average.day_live ? average.day_live + "日" : "-"
                    }</td>
                </tr>`
                    : ""
                }
                ${
                  proj.average_used
                    ? `<tr>
                    <td class="td-left">平均使用时长</td>
                    <td class="td-content">${
                      proj.average_used ? proj.average_used : ""
                    }</td>
                    <td class="td-content td-content-avg">${
                      average.average_used ? average.average_used : "-"
                    }</td>
                </tr>`
                    : ""
                }
                ${
                  proj.client_nums
                    ? `<tr>
                    <td class="td-left">客户数量</td>
                    <td class="td-content">${
                      proj.client_nums ? proj.client_nums : ""
                    }</td>
                    <td class="td-content td-content-avg">${
                      average.client_nums ? average.client_nums : "-"
                    }</td>
                </tr>`
                    : ""
                }
                ${
                  proj.supplier_num
                    ? `<tr>
                    <td class="td-left">供应商数量</td>
                    <td class="td-content">${
                      proj.supplier_num ? proj.supplier_num : ""
                    }</td>
                    <td class="td-content td-content-avg">${
                      average.supplier_num ? average.supplier_num : "-"
                    }</td>
                </tr>`
                    : ""
                }
                ${
                  proj.repeat_rate
                    ? `<tr>
                    <td class="td-left">复购率</td>
                    <td class="td-content">${
                      proj.repeat_rate ? proj.repeat_rate : ""
                    }</td>
                    <td class="td-content td-content-avg">${
                      average.repeat_rate ? average.repeat_rate + "%" : "-"
                    }</td>
                </tr>`
                    : ""
                }
                ${
                  proj.cover_city_num
                    ? `<tr>
                    <td class="td-left">覆盖城市数量</td>
                    <td class="td-content">${
                      proj.cover_city_num ? proj.cover_city_num : ""
                    }</td>
                    <td class="td-content td-content-avg">${
                      average.cover_city_num ? average.cover_city_num : "-"
                    }</td>
                </tr>`
                    : ""
                }
                ${
                  proj.cover_cate_num
                    ? `<tr>
                    <td class="td-left">覆盖品类数量</td>
                    <td class="td-content">${
                      proj.cover_cate_num ? proj.cover_cate_num : ""
                    }</td>
                    <td class="td-content td-content-avg">${
                      average.cover_cate_num ? average.cover_cate_num : "-"
                    }</td>
                </tr>`
                    : ""
                }
            </table>
        </div>
        `;
  }
  if (
    !proj.turnover &&
    !proj.guest_price &&
    !proj.order_num &&
    !proj.sales &&
    !proj.market_cost &&
    !proj.project_cost &&
    !proj.human_cost &&
    !proj.mao_rate &&
    !proj.net_profit &&
    !proj.gross_profit &&
    !proj.cash_flow
  ) {
  } else {
    _html += `
        <div class="finc-table">
            <div class="table-title">财务数据：</div>
            <table>
                <tr>
                    <td class="td-left">财务数据</td>
                    <td class="td-right">项目数据</td>
                    <td class="td-right">行业均值</td>
                </tr>
                ${
                  proj.cash_flow
                    ? `<tr>
                    <td class="td-left">现金流</td>
                    <td class="td-content">${
                      proj.cash_flow ? proj.cash_flow : ""
                    }</td>
                    <td class="td-content td-content-avg">${
                      average.cash_flow ? average.cash_flow : "-"
                    }</td>
                </tr>`
                    : ""
                }
                ${
                  proj.sales
                    ? `<tr>
                    <td class="td-left">销售额（月）</td>
                    <td class="td-content">${proj.sales ? proj.sales : ""}</td>
                    <td class="td-content td-content-avg">${
                      average.sales ? average.sales : "-"
                    }</td>
                </tr>`
                    : ""
                }
                ${
                  proj.sales_grow
                    ? `<tr>
                    <td class="td-left">销售环比增速（月）</td>
                    <td class="td-content">${
                      proj.sales_grow ? proj.sales_grow + "%" : ""
                    }</td>
                    <td class="td-content td-content-avg">${
                      average.sales_grow ? average.sales_grow + "%" : "-"
                    }</td>
                </tr>`
                    : ""
                }
                ${
                  proj.order_num
                    ? `<tr>
                    <td class="td-left">订单量（月）</td>
                    <td class="td-content">${
                      proj.order_num ? proj.order_num : ""
                    }</td>
                    <td class="td-content td-content-avg">${
                      average.order_num ? average.order_num : "-"
                    }</td>
                </tr>`
                    : ""
                }
                ${
                  proj.guest_price
                    ? `<tr>
                    <td class="td-left">客单价</td>
                    <td class="td-content">${
                      proj.guest_price ? proj.guest_price : ""
                    }</td>
                    <td class="td-content td-content-avg">${
                      average.guest_price ? average.guest_price : "-"
                    }</td>
                </tr>`
                    : ""
                }
                ${
                  proj.turnover
                    ? `<tr>
                    <td class="td-left">交易额（月）</td>
                    <td class="td-content">${
                      proj.turnover ? proj.turnover : ""
                    }</td>
                    <td class="td-content td-content-avg">${
                      average.turnover ? average.turnover : "-"
                    }</td>
                </tr>`
                    : ""
                }
                ${
                  proj.mao_rate
                    ? `<tr>
                    <td class="td-left">毛利率</td>
                    <td class="td-content">${
                      proj.mao_rate ? proj.mao_rate : ""
                    }</td>
                    <td class="td-content td-content-avg">${
                      average.mao_rate ? average.mao_rate + "%" : "-"
                    }</td>
                </tr>`
                    : ""
                }
                ${
                  proj.net_profit
                    ? `<tr>
                    <td class="td-left">净利润（月）</td>
                    <td class="td-content">${
                      proj.net_profit ? proj.net_profit : ""
                    }</td>
                    <td class="td-content td-content-avg">${
                      average.net_profit ? average.net_profit : "-"
                    }</td>
                </tr>`
                    : ""
                }
                ${
                  proj.project_cost
                    ? `<tr>
                    <td class="td-left">其它成本（月）</td>
                    <td class="td-content">${
                      proj.project_cost ? proj.project_cost : ""
                    }</td>
                    <td class="td-content td-content-avg">${
                      average.other_cost ? average.other_cost : "-"
                    }</td>
                </tr>`
                    : ""
                }
                ${
                  proj.market_cost
                    ? `<tr>
                    <td class="td-left">营销费用（月）</td>
                    <td class="td-content">${
                      proj.market_cost ? proj.market_cost : ""
                    }</td>
                    <td class="td-content td-content-avg">${
                      average.market_cost ? average.market_cost : "-"
                    }</td>
                </tr>`
                    : ""
                }
                ${
                  proj.human_cost
                    ? `<tr>
                    <td class="td-left">人力费用</td>
                    <td class="td-content">${
                      proj.human_cost ? proj.human_cost : ""
                    }</td>
                    <td class="td-content td-content-avg">${
                      average.human_cost ? average.human_cost : "-"
                    }</td>
                </tr>`
                    : ""
                }
            </table>
        </div>
        `;
  }
  $("#showBusiDataAvg .modal-body").html(_html);
};

PROD.showBusiDataBtn = function(avgTag, proj) {
  // console.log(avgTag)
  var _html = "";
  // if (PROD.content.is_pay != 1 && PROD.content.isClaim == 0) {
  //   $(".no-auth").show();
  //   $("#busi-data .section-content").hide();
  //   return;
  // }
  if (
    !proj.user_nums &&
    !proj.client_nums &&
    !proj.new_day_increase &&
    !proj.new_month_increase &&
    !proj.day_live &&
    !proj.month_rete_rate &&
    !proj.week_rete_rate &&
    !proj.day_rete_rate &&
    !proj.average_used &&
    !proj.cover_city_num &&
    !proj.cover_cate_num &&
    !proj.supplier_type &&
    !proj.supplier_num &&
    !proj.turnover &&
    !proj.guest_price &&
    !proj.order_num &&
    !proj.sales &&
    !proj.market_cost &&
    !proj.project_cost &&
    !proj.human_cost &&
    !proj.mao_rate &&
    !proj.net_profit &&
    !proj.gross_profit &&
    !proj.cash_flow
  ) {
  } else {
    _html += `
    ${!!avgTag ? `<div class="avgBtn">查看相关行业平均值></div>` : ""}
    `;
  }

  $("#busi-data .average-button").html(_html);
};

PROD.showIndustryData = function(proj) {
  var _html = "";

  //判断有无数据
  if (
    !proj.market_size &&
    !proj.user_size &&
    !proj.client_size &&
    !proj.competition_project &&
    !proj.competitors &&
    !proj.our_advantage &&
    !proj.our_disadvantage &&
    !proj.team_goals &&
    !proj.income_goals &&
    !proj.business_goals
  ) {
    // alert('no indu')
    $("#industry-data").hide();
    // $(".nav-bar-item")
    //   .eq(3)
    //   .hide();
    return;
  }

  _html += `
${
    proj.market_size
      ? `<div class="item-box">
<div class="item-title">
市场规模：
</div>
<div class="item-content">
    ${proj.market_size}
</div>
</div>`
      : ""
  }
${
    proj.user_size
      ? `<div class="item-box">
<div class="item-title">
用户规模：
</div>
<div class="item-content">
    ${proj.user_size}
</div>
</div>`
      : ""
  }
${
    proj.client_size
      ? `<div class="item-box">
<div class="item-title">
客户规模：
</div>
<div class="item-content">
    ${proj.client_size}
</div>
</div>`
      : ""
  }
${
    proj.competition_project
      ? `<div class="item-box">
<div class="item-title">
对标产品：
</div>
<div class="item-content">
    ${proj.competition_project}
</div>
</div>`
      : ""
  }
${
    proj.competitors
      ? `<div class="item-box">
<div class="item-title">
主要竞争对手：
</div>
<div class="item-content">
    ${proj.competitors}
</div>
</div>`
      : ""
  }
${
    proj.our_advantage
      ? `<div class="item-box">
<div class="item-title">
我方优势：
</div>
<div class="item-content">
    ${proj.our_advantage}
</div>
</div>`
      : ""
  }
${
    proj.our_disadvantage
      ? `<div class="item-box">
<div class="item-title">
我方劣势：
</div>
<div class="item-content">
    ${proj.our_disadvantage}
</div>
</div>`
      : ""
  }
${
    proj.team_goals || proj.income_goals || proj.business_goals
      ? `<div class="item-box">
<div class="item-title">
未来目标：
</div>
<div class="item-content">
${proj.business_goals ? `<p>业务目标：${proj.business_goals}</p>` : ""}
${proj.income_goals ? `<p>收入目标：${proj.income_goals}</p>` : ""}
${proj.team_goals ? `<p>团队目标：${proj.team_goals}</p>` : ""}
</div>
</div>`
      : ""
  }
`;

  $("#industry-data .section-content").html(_html);
};

PROD.showTeamData = function(proj, people) {
  var _html = "";

  //判断有无数据
  if (
    !proj.team_core_num &&
    !proj.team_form &&
    !proj.team_advantage &&
    !proj.team_how_to_know &&
    !proj.team_whether_work &&
    people.length == 0
  ) {
    // alert('no team')
    $("#team-data").hide();
    $(".nav-bar-item")
      .eq(2)
      .hide();
    return;
  }

  _html += `
${
    proj.team_core_num || proj.team_form
      ? `<div class="item-box">
<div class="item-title">
团队构成：
</div>
<div class="item-content">
${proj.team_core_num ? `<p>团队核心人数：${proj.team_core_num}</p>` : ""}
${proj.team_form ? `<p>部门比重：${proj.team_form}</p>` : ""}
</div>
</div>`
      : ""
  }
${
    proj.team_advantage
      ? `<div class="item-box">
<div class="item-title">
团队优势：
</div>
<div class="item-content">
    ${PAY.multiLineShow(proj.team_advantage)}
</div>
</div>`
      : ""
  }
${
    proj.team_how_to_know
      ? `<div class="item-box">
<div class="item-title">
创始人团队是如何认识的：
</div>
<div class="item-content">
    ${proj.team_how_to_know}
</div>
</div>`
      : ""
  }
${
    proj.team_whether_work
      ? `<div class="item-box">
<div class="item-title">
创业前是否有共事经验：
</div>
<div class="item-content">
    ${proj.team_whether_work}
</div>
</div>`
      : ""
  }
`;
  if (people.length > 0) {
    var p_html = "",
      i = 0,
      len = people.length;
    for (; i < len; i++) {
      p_html += PROD.returnCorePersonHtml(people[i], i);
    }
    _html += `
<div class="item-box">
    <div class="core-team-title">
        核心成员信息：
    </div>
    ${p_html}
</div>
    `;
  }

  $("#team-data .section-content").html(_html);
};

PROD.returnCorePersonHtml = function(data, index) {
  // console.log(data.avatar,data.name)
  data.name = data.name.toString().trim();
  var _html = `
<div class="core-team">
<div class="person-head">
    
    ${
      data.avatar
        ? `
    <div style="background-image:url(${imgUrl}${
            data.avatar
          });" class="img-wrap people-name-${index % 4}"></div>
    `
        : `
    <div class="img-wrap people-name-${index % 4}">${data.name.charAt(0)}</div>
    `
    }
</div>
<div class="person-info">
    <div class="person-name">${data.name}${
    data.name && data.position ? ` | ${data.position}` : ""
  } </div>
    ${
      data.school
        ? `<div class="person-graduate">毕业于${data.school}</div>`
        : ""
    }
    ${
      data.prev_company || data.prev_company_position
        ? `${
            data.prev_company
              ? `原公司：<span class="fromer-company">${
                  data.prev_company
                }</span>`
              : ""
          }
        ${
          data.prev_company_position
            ? `原公司职位：<span class="fromer-position">${
                data.prev_company_position
              }</span>`
            : ""
        }`
        : ""
    }
    <div class="person-introduce">
    ${data.record ? PAY.multiLineShow(data.record) : ""}
    </div>
</div>
</div>
`;
  return _html;
};

PROD.showRoundData = function(rounds) {
  if (!rounds || rounds.length == 0) {
    $("#round-data .section-content").html(
      '<div class="no-round">未融资</div>'
    );
    return;
  }
  var _html = "",
    i = 0,
    len = rounds.length;
  for (; i < len; i++) {
    var data = rounds[i];
    var timeArr = data.annouced_time ? data.annouced_time.split("-") : null;
    _html += `
    <div class="round-info">
    <div class="round-info-item col-1">${
      timeArr ? `${timeArr[0]}.${timeArr[1]}` : ""
    }</div>
    <div class="round-info-item col-2">${
      PAY.financeTypesMap[data.type] ? PAY.financeTypesMap[data.type] : "不详"
    }</div>
    <div class="round-info-item col-3">${
      data.money_unit ? PAY.currencyMap[data.money_unit] : "人民币"
    }</div>
    <div class="round-info-item col-4">${data.money_raised}</div>
    <div class="round-info-item col-5">${data.investor}</div>
    <div class="round-info-item col-6">${data.fa ? data.fa : "不详"}</div>
    <div class="round-info-item col-7">${
      data.evaluating ? data.evaluating : "不详"
    }</div>
    </div>
    `;
  }
  $("#round-data .section-content").append(_html);
};

PROD.showIndustryCommerce = function(data) {
  //判断有无数据
  if (JSON.stringify(data) == "{}") {
    $("#commercial-data").hide();
    $(".nav-bar-item")
      .eq(4)
      .hide();
    return;
  }

  var _html = "";
  _html += `
    <div class="section-content">
    ${
      data.name
        ? `
    <div class="item-box">
    <div class="item-title">
        公司名称：
    </div>
    <div class="item-content">
    ${data.name}
    <a class="qichacha" style="color: #2f7dff;" href=${data.qichacha_url} target="_blank">${data.source?data.source:'企查查'}</a>
    </div>
    </div>
    `
        : ""
    }

    ${
      data.opername
        ? `
    <div class="item-box">
    <div class="item-title">
    法人代表：
    </div>
    <div class="item-content">
    ${data.opername}
    </div>
    </div>
    `
        : ""
    }

    ${
      data.startdate
        ? `
    <div class="item-box">
    <div class="item-title">
    成立时间：
    </div>
    <div class="item-content">
    ${data.startdate.substr(0, 10)}
    </div>
    </div>
    `
        : ""
    }

    ${
      data.registcapi
        ? `
    <div class="item-box">
    <div class="item-title">
    注册资本：
    </div>
    <div class="item-content">
    ${data.registcapi}
    </div>
    </div>
    `
        : ""
    }
    ${
      data.econkind
        ? `
    <div class="item-box">
    <div class="item-title">
    公司类型：
    </div>
    <div class="item-content">
    ${data.econkind}
    </div>
    </div>
    `
        : ""
    }
    ${
      data.status
        ? `
    <div class="item-box">
    <div class="item-title">
    经营状态：
    </div>
    <div class="item-content">
    ${data.status}
    </div>
    </div>
    `
        : ""
    }

    ${
      data.belongorg
        ? `
    <div class="item-box">
    <div class="item-title">
    登记机关：
    </div>
    <div class="item-content">
    ${data.belongorg}
    </div>
    </div>
    `
        : ""
    }

    ${
      data.address
        ? `
    <div class="item-box">
    <div class="item-title">
    公司地址：
    </div>
    <div class="item-content">
    ${data.address}
    </div>
    </div>
    `
        : ""
    }

    ${
      false && data.contactinfo &&
      (data.contactinfo.phonenumber || data.contactinfo.email)
        ? `
    <div class="item-box">
    <div class="item-title">
    联系信息：
    </div>
    <div class="item-content">

    ${
      data.contactinfo && data.contactinfo.phonenumber
        ? `
    <p>联系电话：${data.contactinfo.phonenumber}
    </p>
    `
        : ""
    }

    ${
      data.contactinfo && data.contactinfo.email
        ? `
    <p>联系邮箱：${data.contactinfo.email}
    </p>
    `
        : ""
    }

    </div>
    </div>
    `
        : ""
    }

    ${
      data.partners && data.partners.length > 0
        ? `
    <div class="item-box">
    <div class="item-title">
    股东信息：
    </div>
    <div class="item-content">
    ${PROD.returnPartnersTable(data.partners)}
    </div>
    </div>
    `
        : ""
    }

    ${
      data.employees && data.employees.length > 0
        ? `
    <div class="item-box">
    <div class="item-title">
    主要成员：
    </div>
    <div class="item-content">
    ${PROD.returnEmployeesTable(data.employees)}
    </div>
    </div>
    `
        : ""}
    </div>
    `;
  $("#commercial-data").append(_html);
};

PROD.returnPartnersTable = function(data) {
  var _tr = "",
    _html = "";
  var i = 0,
    len = data.length;
  for (; i < len; i++) {
    var item = data[i];
    _tr += `
<tr>
<td>${item.stockname}</td>
<td>${item.stockpercent ? item.stockpercent : "暂无"}</td>
<td>${item.shouddate ? item.shouddate : "暂无"}</td>
<td>${item.stocktype ? item.stocktype : "暂无"}</td>
</tr>
`;
  }
  _html = `
    <table class="partners">
    <tr>
        <th>股东</th>
        <th>持股比例</th>
        <th>认缴出资日期</th>
        <th>股东类型</th>
    </tr>
${_tr}
    </table>
    `;

  return _html;
};

PROD.returnEmployeesTable = function(data) {
  var _tr = "",
    _html = "";
  var i = 0,
    len = data.length;
  for (; i < len; i++) {
    var item = data[i];
    _tr += `
<tr>
<td>${item.name}</td>
<td>${item.job ? item.job : ""}</td>
</tr>
`;
  }

  _html = `
    <table>
    <tr>
        <th>姓名</th>
        <th>职务</th>
    </tr>
${_tr}
    </table>
    `;

  return _html;
};

PROD._adjustNavWidth = function() {
  var rW = $(".right_container").width();
  $(".nav-bar").width(rW);
};

PROD.adjustNavWidth = function() {
  PROD._adjustNavWidth(); //刚进入页面时
  $(window).on("resize", function() {
    PROD._adjustNavWidth();
  });
};

PROD.adjustNavItemWidth = function() {
  var itemNum = $(".nav-bar-item:visible").length;
  $(".nav-bar-item").width(`${100 / itemNum}%`);
};

PROD.getUpToken = function (_datas, cb) {
  $.ajax({
    url: v1url + "uploader/uptoken",
    type: "GET",
    data: _datas,
    headers: {
      token: $.jStorage.get("localToken"),
      devicetoken: cookie_PENCILNEWSID
    },
    success: function success(data) {
      if (data.code == -1) {
        reLoginOnUc();
        return;
      } else if (data.code == 1000) {
        PROD._up_token = data.data.uptoken;
        PROD._up_key = data.data.key;
        cb && cb(data.data);
      }
    }
  });
};

/*
内容：
  1.新增相关新闻、所在专辑、招聘信息、融资顾问维度；
  2.调整查看BP、获取联系方式、关注项目等样式
  3.调整项目基本信息展示样式

*/
// 发送BP至邮箱
PROD.sendBpForEmail = function(query){
  return new Promise((resolve,reject) => {
    $.ajax({
      url: v1url + PAY.api.payProjectGetBpFileFromEmail,
      method: 'get',
      data: query,
      headers: {
        devicetoken: cookie_PENCILNEWSID,
        token: PROD._token
      },
      dataType: "json",
      success: function (data) {
          // let datas = JSON.parse(data)
          if(data.code == 1000) {
            resolve(data.data);
            showSuccess(data.message);
          }else{
            showWarning(data.message);
          }
      },
      error: function (err) {
        reject(err);
      }
    })
  })
}
PROD.showBpView = function(data) {
  if(data.is_bp != 1) {
    $(".js-bp-data").hide();
    return;
  }
  $(".js-pdf-name").html(data.bp_file_name);
  if(data.bp_visible == 1) {
    $('.js-box-right').html(`<span class="send-out-bp">认领人已设置BP隐藏，请联系创业者获取</span>`);
  }else{
    $('.js-box-right').html(`<button class="get-bp" id="view-bp">点击查看</button>`);
  }
  // let _timer = null;
  // $('body').on('click', '.js-send-out-bp', function(){
  //   console.log("sendBp click....");
  //   _timer = setTimeout(() => {
  //     clearTimeout(_timer);
  //     PROD.sendBpForEmail({
  //       project_id: projectid,
  //       is_bp_file: data
  //     })
  //   }, 1500)
  // })
}

PROD.showFinancingAdvisorView = function(data) {
  // console.log(data);
  if (data === undefined || data.length == 0) {
    $(".js-financing-advisor-data").hide();
    return
  }
  let _html = ``;
  _html += `
    ${data ? data.map((item, index) => {
      return `<li class="advisor-item clearfix">
      ${item.avatar ? `<img src=${item.avatar} alt="" class="img-advisor">` : `<span class="span-advisor people-name-${index % 4}">${item.name.charAt(0)}</span>`}
      <div class="advisor-content">
          <div class="left-content">
              <p class="name">${item.name}</p>
              <p class="position">${item.com ? item.com : ''}${item.job ? '/' + item.job : '' }</p>
          </div>
          <button class="get-contact js-get-advisor-contact" data-id=${item.uid}>联系TA</button>
      </div>
  </li>`
    }).join('') : ''}
  `
  $(".js-advisor-box").html(_html);
}

PROD.showArticleAlbumRecruitList = {
  pagenation: {
    pages: 0,
    current: 1,
    pageSize: 3,
  },
  album_pagenation: {
    pages: 0,
    current: 1,
    pageSize: 3,
  },
  recruit_pagenation: {
    pages: 0,
    current: 1,
    pageSize: 5,
  },
  init: function() {
    Promise.all([
      this.getListData(v1url + "project/news",{
        page: this.pagenation.current,
        page_size: this.pagenation.pageSize
      }),
      this.getListData(v1url + "project/album",{
        page: this.album_pagenation.current,
        page_size: this.album_pagenation.pageSize
      }),
      this.getListData(v1url + "project/position", { 
        page: this.recruit_pagenation.current,
        page_size: this.recruit_pagenation.pageSize
      }),
    ]).then((data) => {
      this.showArticleListView(data[0]);
      // 专辑数量少于3时不采用jpage.js分页
      if(data[1].page_info.total > 3) {
        this.showAlbumsPages(data[1].page_info.total);
      }else{
        $(".js-customBtns").hide();
        this.showAlbumListView(data[1]);
      }
      this.showRecruitListView(data[2]);
    })
    this.handleEvent();
  },
  getListData: function(api, query, method_type = "get") {
    showLoadingGif();
    // 8d1aff0058cdac9b, open_id上测试前需要切换货projectid
    query = Object.assign({}, query, {open_id: projectid})
    return new Promise((resolve,reject) => {
      $.ajax({
        url: api,
        method: method_type,
        data: query,
        headers: {
          devicetoken: cookie_PENCILNEWSID,
          token: PROD._token
        },
        dataType: "json",
        success: function (data) {
            // let datas = JSON.parse(data)
            resolve(data.data);
            closeLoadingGif();
        },
        error: function (err) {
          reject(err);
        }
      })
    })
  },
  showArticleListView: function(data, key) {
    // console.log("showArticleListView", data);
    let pagenation = data.page_info;
    this.pagenation.total_count = pagenation.total;
    let article_list = data.lists || [];
    if(pagenation.total == 0) {
      $(".js-relatednews-data").hide();
      $(".nav-bar-item")
          .eq(5)
          .hide();
      return;
    }
    let _html = ``;
    _html += `
      ${article_list && article_list.length > 0 ?  article_list.map(function(item){
        return `<li class="news-item clearfix">
        ${item.cover_img ? `<img src=${item.cover_img} alt="" class="news-img">` : ''}
        <div class="content-box">
          <a href=${item.url} target="_blank">
            <p class="news-title">${item.title}</p>
          </a>
            <p class="news-build-time">${item.time ? `<span class="span-time">${item.time.split(' ', 1)} </span>`: ''} <span class="span-channel"> ${item.channel}</span></p>
        </div>
    </li>`
      }).join('') : ''}
    `
    if(key == 'jpage') {
      $("#articles_list_container").html(_html);
    }else{
      if( article_list.length < this.pagenation.pageSize &&  article_list.length < 3) {
        $(".js-getmore-btn-box").html(`<span class="get-more">没有更多了</span>`)
      }
      $("#articles_list_container").append(_html);
    }
  },
  showAlbumListView: function(data) {
    let album_list = data.lists || [];
    if(album_list.length == 0) {
      $(".album-data").hide();
      $(".nav-bar-item")
          .eq(7)
          .hide();
      return;
    }
    let _html = ``;
    _html += `
      ${album_list && album_list.length > 0 ? album_list.map((item) => {
        return `
        <li class="album-item col-md-4 js-album-item">
          <a href=""></a>
          <a href="/album/${item.id}" target="_blank">
            <p class="title">${item.name}</p>
          </a>
          <p class="albumDetail">
            <span>共${item.project_count}个项目</span>
            <span>${item.publish_time ? item.publish_time.split(' ', 1) : ''}</span>
          </p>
          <img src=${item.image} alt="" class="album-img">
        </li>
        `
      }).join("") : ''}
    `
    $("#album_list_container").html(_html);
    $(".js-album-item").fadeIn(500);
  },
  showRecruitListView: function(data, key) {
    // console.log(data);
    let pagenation = data.page_info;
    this.recruit_pagenation.total_count = pagenation.total;
    let recruit_list = data.lists || [];
    if(pagenation.total == 0) {
      $(".js-recruit-data").hide();
      $(".nav-bar-item")
          .eq(8)
          .hide();
      return;
    }
    let _html = ``;
    _html += `
      ${recruit_list && recruit_list.length > 0 ?  recruit_list.map(function(item){
        return `<div class="competitor-info recruit-info">
        <div class="competitor-info-item col-co-1">${item.position ? item.position : ''}${item.experience ? '/' + item.experience : '' }${item.edu ? '/' + item.edu : '' }${item.type ? '/' + item.type : '' }</div>
        <div class="competitor-info-item col-co-2">${item.city}</div>
        <div class="competitor-info-item col-co-3">${item.salary}</div>
        <div class="competitor-info-item col-co-4">${item.create_time ? item.create_time.split(' ', 1) : '' }</div>
    </div>`
      }).join('') : ''}
    `
    if(key == 'jpage') {
      $("#recruit_list_container").html(_html);
    }else{
      $("#recruit_list_container").append(_html);
      // console.log(recruit_list.length, this.recruit_pagenation.pageSize)
      if( recruit_list.length < this.recruit_pagenation.pageSize ) {
        $(".js-recruit-getmore-box").html(`<span class="get-more">没有更多了</span>`)
      }
    }
  },
  showArticlesPages: function(pages) {
    var pageContainerHTML = "";
    var i = 1;
    for (; i <= pages; i++) {
      pageContainerHTML +=
        "<div class='pages_appended' pageNum='" + i + "'></div>";
    }
    $(".js-getmore-btn-box").hide();
    $("#articles_pages_container").show();
    $("#articles_list_container").html(pageContainerHTML);
    $(".js-articles-page").jPages({
      containerID: "articles_list_container",
      perPage: 8,
      startPage: 1,
      startRange: 0,
      minHeight: false,
      first: "首页",
      last: "尾页",
      callback: (pages, items) => {
        // console.log(pages);
        showLoadingGif();
        this.pagenation.current = pages.current;
        this.getListData(v1url + "project/news",{
          page: this.pagenation.current,
          page_size: this.pagenation.pageSize
        }).then((data) => {
          this.showArticleListView(data, 'jpage');
          closeLoadingGif();
        })
      }
    });
    // 跳转到指定页的事件
    // $("#page-jump-btn").click(function() {
    //   var pageNum = $("#page-jump-input").val();
    //   pageNum = parseInt(pageNum);
    //   $("#articles_pages").jPages(pageNum);
    //   $("#page-jump-input").val("");
    // });
  },
  showAlbumsPages: function (pages) {
    var pageContainerHTML = "";
    var i = 1;
    for (; i <= pages; i++) {
      pageContainerHTML +=
        "<div class='pages_appended' pageNum='" + i + "'></div>";
    }
    $("#album_list_container").append(pageContainerHTML);
    $("div.js-album-pages").jPages({
      containerID: "album_list_container",
      perPage: 3,
      startPage: 1,
      startRange: 0,
      first: false,
      previous: "span.arrowPrev",
      next: "span.arrowNext",
      last: false,
      callback: (pages, items) => {
        this.album_pagenation.current = pages.current;
        this.getListData(v1url + "project/album",{
          page: this.album_pagenation.current,
          page_size: this.album_pagenation.pageSize
        }).then((data) => {
          this.showAlbumListView(data);
        });
      }
    });
  },
  showRecruitPages: function(pages) {
    var pageContainerHTML = "";
    var i = 1;
    for (; i <= pages; i++) {
      pageContainerHTML +=
        "<div class='pages_appended' pageNum='" + i + "'></div>";
    }
    $(".js-recruit-getmore-box").hide();
    $(".js-recruit-pages-container").show();
    $("#recruit_list_container").html(pageContainerHTML);
    $(".js-recruit-page").jPages({
      containerID: "recruit_list_container",
      perPage: 10,
      startPage: 1,
      startRange: 0,
      minHeight: false,
      first: "首页",
      last: "尾页",
      callback: (pages, items) => {
        // console.log(pages);
        showLoadingGif();
        this.recruit_pagenation.current = pages.current;
        this.getListData(v1url + "project/position", { 
          page: this.recruit_pagenation.current,
          page_size: this.recruit_pagenation.pageSize
        }).then((data) => {
          this.showRecruitListView(data, 'jpage');
          closeLoadingGif();
        })
      }
    });
  },
  handleEvent: function() {
    // console.log(this);
    // 相关新闻查看更多
    $(".js-get-more").on('click', () => {
      this.pagenation.current += 1;
      if(this.pagenation.current < 3 && this.pagenation.pageSize == 3) {
        this.getListData(v1url + "project/news",{
          page: this.pagenation.current,
          page_size: this.pagenation.pageSize
        }).then((data) => {
          this.showArticleListView(data);
        })
      }else{
        this.pagenation.current = 1;
        this.pagenation.pageSize = 8;
        this.showArticlesPages(this.pagenation.total_count);
      }
    });

    // 招聘信息查看更多
    $(".js-recruit-getmore").on('click', () => {
      this.recruit_pagenation.current += 1;
      if(this.recruit_pagenation.total_count <=10) {
        this.getListData(v1url + "project/position", { 
          page: this.recruit_pagenation.current,
          page_size: this.recruit_pagenation.pageSize
        }).then((data) => {
          this.showRecruitListView(data);
        })
      }else{
        this.recruit_pagenation.current = 1;
        this.recruit_pagenation.pageSize = 10;
        this.showRecruitPages(this.recruit_pagenation.total_count);
      }
    })
    
  }
}